import { Injectable } from '@angular/core';

import type {
  NoteAvatarAuthor,
  NoteAvatarInputValues,
  NoteAvatarUpdateStrategy,
} from '../note-avatar.types';

@Injectable()
export class RtvNoteAvatarUpdate implements NoteAvatarUpdateStrategy {
  public getValues({
    author,
    triggered,
  }: {
    author: NoteAvatarAuthor;
    triggered: boolean | null;
  }): NoteAvatarInputValues {
    return {
      type: !triggered && !!author ? 'image' : 'icon',
      context: 'other',
      iconName: !triggered && !author ? 'person' : 'automated-actions',
      imageSrc: !triggered && !author ? null : (author?.photoThumbUrl ?? null),
    };
  }
}
